import { gql } from "apollo-boost";

const BULK_FULFILL = gql`
  mutation bulkFulfill($input: BulkFulfill!) {
    bulkFulfill(input: $input) {
      status
      data
      error
    }
  }
`;

export default BULK_FULFILL;
